import React from 'react'
import { Modal } from 'react-bootstrap'
import './ModalZoomAlert.css'
import { images } from 'Assets/Images'

export const ModalZoomAlert = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop
      enforceFocus={false}
      centered
      contentClassName="printer-modal-root-wrapper">
      <div className="printer-modal-wrapper">
        <div className="printer-modal-content">
          <h3
            style={{
              color: '#022767',
              fontSize: '24px',
              fontWeight: 'bold',
              marginTop: '10px',
            }}>
            ¡Atención! 🚨
          </h3>
          <p
            style={{
              color: '#022767',
              fontSize: '16px',
              fontWeight: 'bold',
              textAlign: 'center',
            }}>
            Para una correcta impresión, por favor ajusta el zoom de tu
            navegador al 100%
          </p>
          <div className="printer-modal-content-option-wrapper">
            <img
              src={images.printer.templates.zoomInstructions}
              alt="zoom-instructions"
              style={{
                width: '490px',
                objectFit: 'cover',
                border: '4px solid #000',
              }}
            />
          </div>
          <button onClick={onClose} className="printer-modal-content-button">
            Entendido
          </button>
        </div>
      </div>
    </Modal>
  )
}
